import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import apiService from "../../services/api.js";
import EventCard from "../EventCard.js";
import godImage from "../../images/god.jpg";
import { Box, Link, Typography } from "@mui/material";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HomeEvents from "../home-events/home-events.js";
import { useAppSettings } from "../../contexts/AppSettingsContext";

function EventsSlider() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openPopup, setOpenPopup] = useState(false);

  const { homeEventsButton } = useAppSettings() || {};

  useEffect(() => {
  apiService
    .getEvents()
    .then((response) => {
      if (response.data.success && Array.isArray(response.data.data)) {
        const allEvents = response.data.data.flatMap(category =>
          category.events.map(event => ({
            ...event,
            category_name: category.name,
          }))
        );

        const currentDate = new Date();

        // ✅ Include BOTH upcoming and ongoing events
        const filteredEvents = allEvents.filter(event => {
          const start = new Date(event.start_date_time);
          const end = event.end_date_time ? new Date(event.end_date_time) : null;

          // Ongoing
          if (end && start <= currentDate && end >= currentDate) return true;
          if (!end && start.toDateString() === currentDate.toDateString()) return true;

          // Upcoming
          if (start > currentDate) return true;

          return false;
        });

        // ✅ Sort: ongoing first, then upcoming
        filteredEvents.sort((a, b) => {
          const startA = new Date(a.start_date_time);
          const startB = new Date(b.start_date_time);

          const isOngoingA = (a.end_date_time && startA <= currentDate && new Date(a.end_date_time) >= currentDate) 
            || (!a.end_date_time && startA.toDateString() === currentDate.toDateString());
          const isOngoingB = (b.end_date_time && startB <= currentDate && new Date(b.end_date_time) >= currentDate) 
            || (!b.end_date_time && startB.toDateString() === currentDate.toDateString());

          if (isOngoingA && !isOngoingB) return -1;
          if (!isOngoingA && isOngoingB) return 1;

          return startA - startB; // Upcoming in ascending order
        });

        setEvents(filteredEvents);
      } else {
        setEvents([]);
      }

      setLoading(false);
    })
    .catch((error) => {
      console.error("Error fetching events:", error);
      setLoading(false);
    });
}, []);


  if (loading) {
    return <Box>Loading events...</Box>;
  }

  if (!events.length) {
    return (
      <Box className="static-event-card">
        <Box
          component="img"
          src={godImage}
          alt="Past Events"
          className="w-100 theme-radius"
        />
        <Typography>No upcoming events available</Typography>
        <Link href="/events" className="btn btn-primary">
          View Past Events
        </Link>
      </Box>
    );
  }

  const settings = {
    dots: events.length > 3,
    infinite: events.length > 3,
    arrows: events.length > 3,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          dots: false,
          infinite: events.length > 1,
          arrows: events.length > 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          dots: false,
          infinite: events.length > 1,
          arrows: events.length > 1,
        },
      },
    ],
  };

  return (
    <>
      <Slider {...settings}>
        {/* New "Weekly Updates" Slide at the Beginning */}
        {homeEventsButton && (
    <Box
      key="weekly"
      className="static-event-card"
      onClick={() => setOpenPopup(true)}
    >
      <Box
        component="img"
        src={godImage}
        alt="Weekly Updates"
        className="w-100 theme-radius"
      />
      <Link className="btn btn-primary">
        {homeEventsButton}
      </Link>
    </Box>
  )}
        {events.map((event, index) => (
          <Box key={index}>
            <EventCard event={event} />
          </Box>
        ))}
        {/* "Past Events" Slide as the Last Slide */}
        <Box key="static" className="static-event-card">
          <Box
            component="img"
            src={godImage}
            alt="Past Events"
            className="w-100 theme-radius"
          />
          <Link href="/events" className="btn btn-primary">
            View Past Events
          </Link>
        </Box>
      </Slider>
      {/* Popup for Weekly Updates */}
      <Dialog
  open={openPopup}
  onClose={() => setOpenPopup(false)}
  maxWidth="md"
  fullWidth
  sx={{
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0,0,0,0.8)", // darker background
    },
  }}
>
  <IconButton
    aria-label="close"
    onClick={() => setOpenPopup(false)}
    sx={{
      position: "absolute",
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
      zIndex: 1,
    }}
  >
    <CloseIcon />
  </IconButton>
  <DialogContent sx={{ position: "relative" }}>
    <HomeEvents />
  </DialogContent>
</Dialog>
    </>
  );
}

export default EventsSlider;